import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ConsultaFuenteI } from 'src/app/modelos/ConsultaFuente';
import { EstadoInfoChvI } from 'src/app/modelos/EstadoInformacionChv';
import { EstadoInfoFiviI } from 'src/app/modelos/EstadoInformacionFivi';
import { FichaAnalisisCHVI } from 'src/app/modelos/FichaAnalisisCHV';
import { FichaAnalisisFIVII } from 'src/app/modelos/FichaAnalisisFIVI';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { PeriodoReporteI } from 'src/app/modelos/PeriodoReporte';
import { PeriodoReporteFiviI } from 'src/app/modelos/PeriodoReporteFivi';
import { ResCargueExcel } from 'src/app/modelos/ResCargueExcel';
import { ResConsultaExcel } from 'src/app/modelos/ResConsulta';
import { VistaAnalisisInfI } from 'src/app/modelos/VistaAnalisisInf';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { AnalisisService } from '../../servicios/analisis/analisis.service';
//xlsx utils : npm install xlsx
import { read, writeFileXLSX } from "xlsx";
import * as XLSX from 'xlsx';
import { ResCargueExcelFivi } from 'src/app/modelos/ResCargueExcelFivi';
import { FichaAnalisisFiviDto } from 'src/app/modelos/fichasAnalisis/FichaAnalisisFiviDto';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-analisisfivi',
  templateUrl: './analisisfivi.component.html',
  styleUrls: ['./analisisfivi.component.css']
})
export class AnalisisfiviComponent implements OnDestroy,OnInit {

  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  aniosVigen: Number[];
  PeriodoSeleccionado : PeriodoReporteFiviI = new PeriodoReporteFiviI;
  anioConsulta : Number = 0;
  consucutivoConsulta : Number = 0;

  ListaEstadosFuentes : VistaAnalisisInfI[];
  PeriodoActivo : PeriodoReporteFiviI = new PeriodoReporteFiviI;
  PeriodosConsultar : PeriodoReporteFiviI[];
  IdPeriodoConsulta : BigInteger;
  PeriodoFichaGeneralMenTri : PeriodoReporteFiviI;
  PeriodoFichaGeneralTrimestral : String;
  PeriodoActual : String;
  PeriodoCol1 : String;
  PeriodoCol2 : String;
  PeriodoCol4 : String;
  PeriodoCol5 : String;
  PeriodoFichaGeneral : String;
  FGTablaOperFin12ValDes : FichaAnalisisFiviDto[];
  FGTablaOperFin1ValDes : FichaAnalisisFiviDto[];
  FGTablaOperFin2ValDes : FichaAnalisisFiviDto[];
  FGTablaOperFin3ValDes : FichaAnalisisFiviDto[];
  FGTablaOperFin4ValDes : FichaAnalisisFiviDto[];
  FGTablaOperFin12NumCre : FichaAnalisisFiviDto[];
  FGTablaOperFin1NumCre : FichaAnalisisFiviDto[];
  FGTablaOperFin2NumCre : FichaAnalisisFiviDto[];
  FGTablaOperFin3NumCre : FichaAnalisisFiviDto[];
  FGTablaOperFin4NumCre : FichaAnalisisFiviDto[];
  PeriodoFichaAnalisisIndividual : PeriodoReporteFiviI;
  FuenteFichaIndividual : fuenteI = new fuenteI;
  PeriodoFichaIndividual : String;
  EstadoInfomacionFuente : EstadoInfoFiviI = new EstadoInfoFiviI;
  NovedadFichaIndividual : String;
  FITablaOperFin12ValDes : FichaAnalisisFiviDto[];
  FITablaOperFin1ValDes : FichaAnalisisFiviDto[];
  FITablaOperFin2ValDes : FichaAnalisisFiviDto[];
  FITablaOperFin3ValDes : FichaAnalisisFiviDto[];
  FITablaOperFin4ValDes : FichaAnalisisFiviDto[];
  FITablaOperFin12NumCre : FichaAnalisisFiviDto[];
  FITablaOperFin1NumCre : FichaAnalisisFiviDto[];
  FITablaOperFin2NumCre : FichaAnalisisFiviDto[];
  FITablaOperFin3NumCre : FichaAnalisisFiviDto[];
  FITablaOperFin4NumCre : FichaAnalisisFiviDto[];
  TrimestreConsultaReporte : Number;
  CargueMasivo : ConsultaFuenteI = new ConsultaFuenteI;
  ResultadoConsulta : any;
  VercargueFuente : Boolean;
  AprobarcargueFuente : Boolean;
  BtnAprobar : Boolean;
  CertNoMovi : Boolean;
  CargueAprobado : Boolean;
  MensualGeneral : Boolean;
  TrimestralGeneral : Boolean;
  MensualIndividual : Boolean;
  TrimestralIndividual : Boolean;

  @ViewChild('OpenModalPreguntaFichaGeneral') OpenModalPreguntaFichaGeneral: ElementRef;
  @ViewChild('CloseModalPreguntaFichaGeneral') CloseModalPreguntaFichaGeneral: ElementRef;
  @ViewChild('OpenModalFichaGeneral') OpenModalFichaGeneral: ElementRef;
  @ViewChild('CloseModalFichaGeneral') CloseModalFichaGeneral: ElementRef;
  @ViewChild('OpenModalPreguntaFichaIndividual') OpenModalPreguntaFichaIndividual: ElementRef;
  @ViewChild('CloseModalPreguntaFichaIndividual') CloseModalPreguntaFichaIndividual: ElementRef;
  @ViewChild('OpenModalFichaIndividual') OpenModalFichaIndividual: ElementRef;
  @ViewChild('CloseModalFichaIndividual') CloseModalFichaIndividual: ElementRef;

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService,
    private analisisService:AnalisisService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ estados"
        }
    };
    this.MensualGeneral = false;
    this.TrimestralGeneral = false;
    this.MensualIndividual = false;
    this.TrimestralIndividual = false;
    this.VercargueFuente = false;
    this.AprobarcargueFuente = false;
    this.BtnAprobar = false;
    this.CertNoMovi = false;
    this.analisisService.consultarPeriodoActivoFIVI().subscribe(PActivo=>{
      this.anioConsulta = Number(PActivo.anio);
      this.consucutivoConsulta = Number(PActivo.consecutivoPeriodo);

      this.PeriodoActivo = PActivo;
      this.IdPeriodoConsulta = PActivo.id;
      this.PeriodoActual = PActivo.anio + " - " + PActivo.consecutivoPeriodo;

      this.api.EstadosParaPeriodoFivi(PActivo.id).subscribe(Lista=>{
        this.ListaEstadosFuentes = Lista;
        this.dtTrigger.next();
      });
    });
    this.api.listaPeriodosCalendarioFivi().subscribe(Lista1=>{
      this.PeriodosConsultar = Lista1;
    });
    this.analisisService.getListaAniosVigenciaFivi().subscribe(respuesta0=>{
      this.aniosVigen = respuesta0;
    });
    /*this.analisisService.fichaAnalisisMensualGeneralFivi(2,2021).subscribe(respuestaPrueba=>{
      console.log(respuestaPrueba);
    })*/
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  regresarAnalisis(){
    this.router.navigate(['analisis']);
  }

  CosultarListaEstados(IdPeriodo){
    this.MensualGeneral = false;
    this.TrimestralGeneral = false;
    this.MensualIndividual = false;
    this.TrimestralIndividual = false;
    this.VercargueFuente = false;
    this.AprobarcargueFuente = false;
    this.BtnAprobar = false;
    this.CertNoMovi = false;
    this.IdPeriodoConsulta = IdPeriodo;
    this.api.EstadosParaPeriodoFivi(IdPeriodo).subscribe(Lista2=>{
      this.ListaEstadosFuentes = Lista2;
      this.reinicializarDataTable();
    });
  }

  reinicializarDataTable(): void {
    this.dtElement.dtInstance.then((dtInstance: any) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  peridoPorAnioMes(){
    this.analisisService.periodoFiviPorAnioMes(this.anioConsulta,this.consucutivoConsulta).subscribe(respuesta2=>{
      this.PeriodoSeleccionado = respuesta2;
      this.IdPeriodoConsulta = respuesta2.id;
      this.CosultarListaEstados(respuesta2.id);
    });
  }

  ResetVariables(){
    this.MensualGeneral = false;
    this.TrimestralGeneral = false;
    this.MensualIndividual = false;
    this.TrimestralIndividual = false;
    this.VercargueFuente = false;
    this.AprobarcargueFuente = false;
    this.BtnAprobar = false;
    this.CertNoMovi = false;
  }

  PreguntarTipoInformacionFichaGeneral(){
    this.MensualGeneral = false;
    this.TrimestralGeneral = false;
    this.OpenModalPreguntaFichaGeneral.nativeElement.click();
  }

  VerificarTipoInformacionFichaGeneral(){
    if(!this.MensualGeneral && !this.TrimestralGeneral){
      this.toastr.warning('Debe seleccionar una opción.', 'Advertencia!');
    } else {
      this.api.PeriodoFiviPorId(this.IdPeriodoConsulta).subscribe(Result=>{
        this.PeriodoFichaGeneralMenTri = Result;
        if(this.MensualGeneral){
          this.PeriodoFichaGeneral = Result.anio + " - " + Result.consecutivoPeriodo;
          if(Result.consecutivoPeriodo == "1"){
            this.PeriodoCol1 = (Number(Result.anio)-1) + " - 12";
            this.PeriodoCol2 = Result.anio + " - " + Result.consecutivoPeriodo;
            this.PeriodoCol4 = (Number(Result.anio)-1) + " - " + Result.consecutivoPeriodo;
            this.PeriodoCol5 = Result.anio + " - " + Result.consecutivoPeriodo;
          } else {
            this.PeriodoCol1 = Result.anio + " - " + (Number(Result.consecutivoPeriodo)-1);
            this.PeriodoCol2 = Result.anio + " - " + Result.consecutivoPeriodo;
            this.PeriodoCol4 = (Number(Result.anio)-1) + " - " + Result.consecutivoPeriodo;
            this.PeriodoCol5 = Result.anio + " - " + Result.consecutivoPeriodo;
          }
          this.InformacionMensualFichaGeneral();
        }else if(this.TrimestralGeneral){
          let FechaHoy = new Date()
          let HoyMes = FechaHoy.getMonth()+1;
          let HoyAnio = FechaHoy.getFullYear();
          if(Result.consecutivoPeriodo == "1" || Result.consecutivoPeriodo == "2" || Result.consecutivoPeriodo == "3"){
            if((HoyMes>=4&&HoyAnio==Number(Result.anio))||(HoyAnio>Number(Result.anio))) {
              this.PeriodoFichaGeneral = (Result.anio) + " - 1";
              this.PeriodoCol1 = (Number(Result.anio)-1) + " - 4";
              this.PeriodoCol2 = (Result.anio) + " - 1";
              this.PeriodoCol4 = (Number(Result.anio)-1) + " - 1";
              this.PeriodoCol5 = (Result.anio) + " - 1";
              this.InformacionTrimestralFichaGeneral(1);
            }else{
              this.toastr.warning('La información para el trimestre no esta completa.', 'Advertencia!');
            }
          }else if(Result.consecutivoPeriodo == "4" || Result.consecutivoPeriodo == "5" || Result.consecutivoPeriodo == "6"){
            if((HoyMes>=7&&HoyAnio==Number(Result.anio))||(HoyAnio>Number(Result.anio))){
              this.PeriodoFichaGeneral = Result.anio + " - 2";
              this.PeriodoCol1 = (Result.anio) + " - 1";
              this.PeriodoCol2 = Result.anio + " - 2";
              this.PeriodoCol4 = (Number(Result.anio)-1) + " - 2";
              this.PeriodoCol5 = Result.anio + " - 2";
              this.InformacionTrimestralFichaGeneral(2);
            }else{
              this.toastr.warning('La información para el trimestre no esta completa.', 'Advertencia!');
            }
          }else if(Result.consecutivoPeriodo == "7" || Result.consecutivoPeriodo == "8" || Result.consecutivoPeriodo == "9"){
            if((HoyMes>=10&&HoyAnio==Number(Result.anio))||(HoyAnio>Number(Result.anio))){
              this.PeriodoFichaGeneral = Result.anio + " - 3";
              this.PeriodoCol1 = (Result.anio) + " - 2";
              this.PeriodoCol2 = Result.anio + " - 3";
              this.PeriodoCol4 = (Number(Result.anio)-1) + " - 3";
              this.PeriodoCol5 = Result.anio + " - 3";
              this.InformacionTrimestralFichaGeneral(3);
            }else{
              this.toastr.warning('La información para el trimestre no esta completa.', 'Advertencia!');
            }
          }else if(Result.consecutivoPeriodo == "10" || Result.consecutivoPeriodo == "11" || Result.consecutivoPeriodo == "12"){
            if((HoyMes>=1&&HoyAnio==(Number(Result.anio)+1))||(HoyAnio>(Number(Result.anio)+1))){
              this.PeriodoFichaGeneral = Result.anio + " - 4";
              this.PeriodoCol1 = (Result.anio) + " - 3";
              this.PeriodoCol2 = Result.anio + " - 4";
              this.PeriodoCol4 = (Number(Result.anio)-1) + " - 4";
              this.PeriodoCol5 = Result.anio + " - 4";
              this.InformacionTrimestralFichaGeneral(4);
            }else{
              this.toastr.warning('La información para el trimestre no esta completa.', 'Advertencia!');
            }
          }else{
            this.toastr.error('Error definicion de periodo de consulta.', 'Error!');
          }
        }
      });
    }
  }

  InformacionMensualFichaGeneral(){
    this.CloseModalPreguntaFichaGeneral.nativeElement.click();
    this.OpenModalFichaGeneral.nativeElement.click();
    this.analisisService.fichaAnalisisMensualGeneralFivi(this.PeriodoFichaGeneralMenTri.consecutivoPeriodo,this.PeriodoFichaGeneralMenTri.anio).subscribe(respuesta3=>{
      //console.log(respuesta3);
      this.FGTablaOperFin12ValDes= respuesta3.datosTabla1Desembolsos;
      this.FGTablaOperFin1ValDes= respuesta3.datosTabla2Desembolsos;
      this.FGTablaOperFin2ValDes= respuesta3.datosTabla3Desembolsos;
      this.FGTablaOperFin3ValDes= respuesta3.datosTabla4Desembolsos;
      this.FGTablaOperFin4ValDes= respuesta3.datosTabla5Desembolsos;
      this.FGTablaOperFin12NumCre= respuesta3.datosTabla1NumeroCreditos;
      this.FGTablaOperFin1NumCre= respuesta3.datosTabla2NumeroCreditos;
      this.FGTablaOperFin2NumCre= respuesta3.datosTabla3NumeroCreditos;
      this.FGTablaOperFin3NumCre= respuesta3.datosTabla4NumeroCreditos;
      this.FGTablaOperFin4NumCre= respuesta3.datosTabla5NumeroCreditos;
    });
  }

  InformacionTrimestralFichaGeneral(ConsecutivoTrimestre){
    this.CloseModalPreguntaFichaGeneral.nativeElement.click();
    this.OpenModalFichaGeneral.nativeElement.click();
    this.analisisService.fichaAnalisisTrimestralGeneralFivi(ConsecutivoTrimestre,this.PeriodoFichaGeneralMenTri.anio).subscribe(respuesta3=>{
      //console.log(respuesta3);
      this.FGTablaOperFin12ValDes= respuesta3.datosTabla1Desembolsos;
      this.FGTablaOperFin1ValDes= respuesta3.datosTabla2Desembolsos;
      this.FGTablaOperFin2ValDes= respuesta3.datosTabla3Desembolsos;
      this.FGTablaOperFin3ValDes= respuesta3.datosTabla4Desembolsos;
      this.FGTablaOperFin4ValDes= respuesta3.datosTabla5Desembolsos;
      this.FGTablaOperFin12NumCre= respuesta3.datosTabla1NumeroCreditos;
      this.FGTablaOperFin1NumCre= respuesta3.datosTabla2NumeroCreditos;
      this.FGTablaOperFin2NumCre= respuesta3.datosTabla3NumeroCreditos;
      this.FGTablaOperFin3NumCre= respuesta3.datosTabla4NumeroCreditos;
      this.FGTablaOperFin4NumCre= respuesta3.datosTabla5NumeroCreditos;
    });
  }

  ExportarExcelFichaAnalisisGeneral() {
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById('TablaValDesemOperFinan12'));
    XLSX.utils.book_append_sheet(workbook, ws1, "VD OP 1 y 2");
    var ws2 = XLSX.utils.table_to_sheet(document.getElementById('TablaValDesemOperFinan1'));
    XLSX.utils.book_append_sheet(workbook, ws2, "VD OP 1");
    var ws3 = XLSX.utils.table_to_sheet(document.getElementById('TablaValDesemOperFinan2'));
    XLSX.utils.book_append_sheet(workbook, ws3, "VD OP 2");
    var ws4 = XLSX.utils.table_to_sheet(document.getElementById('TablaValDesemOperFinan3'));
    XLSX.utils.book_append_sheet(workbook, ws4, "VD OP 3");
    var ws5 = XLSX.utils.table_to_sheet(document.getElementById('TablaValDesemOperFinan4'));
    XLSX.utils.book_append_sheet(workbook, ws5, "VD OP 4");
    var ws6 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumerCrediOperFinan12'));
    XLSX.utils.book_append_sheet(workbook, ws6, "NC OP 1 y 2");
    var ws7 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumerCrediOperFinan1'));
    XLSX.utils.book_append_sheet(workbook, ws7, "NC OP 1");
    var ws8 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumerCrediOperFinan2'));
    XLSX.utils.book_append_sheet(workbook, ws8, "NC OP 2");
    var ws9 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumerCrediOperFinan3'));
    XLSX.utils.book_append_sheet(workbook, ws9, "NC OP 3");
    var ws10 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumerCrediOperFinan4'));
    XLSX.utils.book_append_sheet(workbook, ws10, "NC OP 4");
    XLSX.writeFile(workbook, "FichaAnalisisGeneral.xlsx");
  }

  PreguntarTipoInformacionFichaIndividual(idfuente){
    this.MensualIndividual = false;
    this.TrimestralIndividual = false;
    this.api.EstadoInfParaFuenteFivi(this.IdPeriodoConsulta,idfuente).subscribe(Result11=>{
      this.EstadoInfomacionFuente = Result11;
      this.NovedadFichaIndividual = Result11.novedadSis.split("-",1) + "/ " + Result11.novedadUsu;
      if(Result11.novedadUsu.split(".",1)[0]=="14"){
        this.CertNoMovi = true;
      }
      if(Result11.observacionSis != null){
        this.BtnAprobar = true;
      }
    });
    this.OpenModalPreguntaFichaIndividual.nativeElement.click();
  }

  VerificarTipoInformacionFichaIndividual(){
    this.TrimestreConsultaReporte = 0;
    if(!this.MensualIndividual && !this.TrimestralIndividual){
      this.toastr.warning('Debe seleccionar una opción.', 'Advertencia!');
    } else {
      this.api.PeriodoFiviPorId(this.EstadoInfomacionFuente.idPeriodo.id).subscribe(Result12=>{
        this.PeriodoFichaAnalisisIndividual = Result12;
        this.api.getFuenteById(this.EstadoInfomacionFuente.idFuente.id).subscribe(Result13=>{
          this.FuenteFichaIndividual = Result13;
        });
        if(this.MensualIndividual){
          this.PeriodoFichaIndividual = Result12.anio + " - " + Result12.consecutivoPeriodo;
          if(Result12.consecutivoPeriodo == "1"){
            this.PeriodoCol1 = (Number(Result12.anio)-1) + " - 12";
            this.PeriodoCol2 = Result12.anio + " - " + Result12.consecutivoPeriodo;
            this.PeriodoCol4 = (Number(Result12.anio)-1) + " - " + Result12.consecutivoPeriodo;
            this.PeriodoCol5 = Result12.anio + " - " + Result12.consecutivoPeriodo;
          } else {
            this.PeriodoCol1 = Result12.anio + " - " + (Number(Result12.consecutivoPeriodo)-1);
            this.PeriodoCol2 = Result12.anio + " - " + Result12.consecutivoPeriodo;
            this.PeriodoCol4 = (Number(Result12.anio)-1) + " - " + Result12.consecutivoPeriodo;
            this.PeriodoCol5 = Result12.anio + " - " + Result12.consecutivoPeriodo;
          }
          this.InformacionMensualFichaIndividual();
        }else if(this.TrimestralIndividual){
          let FechaHoy = new Date()
          let HoyMes = FechaHoy.getMonth()+1;
          let HoyAnio = FechaHoy.getFullYear();
          if(Result12.consecutivoPeriodo == "1" || Result12.consecutivoPeriodo == "2" || Result12.consecutivoPeriodo == "3"){
            if((HoyMes>=4&&HoyAnio==Number(Result12.anio))||(HoyAnio>Number(Result12.anio))){
              this.PeriodoFichaIndividual = (Result12.anio) + " - 1";
              this.PeriodoCol1 = (Number(Result12.anio)-1) + " - 4";
              this.PeriodoCol2 = (Result12.anio) + " - 1";
              this.PeriodoCol4 = (Number(Result12.anio)-1) + " - 1";
              this.PeriodoCol5 = (Result12.anio) + " - 1";
              this.TrimestreConsultaReporte = 1;
              this.InformacionTrimestralFichaIndividual(1);
            }else{
              this.toastr.warning('La información para el trimestre no esta completa.', 'Advertencia!');
            }
          }else if(Result12.consecutivoPeriodo == "4" || Result12.consecutivoPeriodo == "5" || Result12.consecutivoPeriodo == "6"){
            if((HoyMes>=7&&HoyAnio==Number(Result12.anio))||(HoyAnio>Number(Result12.anio))){
              this.PeriodoFichaIndividual = Result12.anio + " - 2";
              this.PeriodoCol1 = (Result12.anio) + " - 1";
              this.PeriodoCol2 = Result12.anio + " - 2";
              this.PeriodoCol4 = (Number(Result12.anio)-1) + " - 2";
              this.PeriodoCol5 = Result12.anio + " - 2";
              this.TrimestreConsultaReporte = 2;
              this.InformacionTrimestralFichaIndividual(2);
            }else{
              this.toastr.warning('La información para el trimestre no esta completa.', 'Advertencia!');
            }
          }else if(Result12.consecutivoPeriodo == "7" || Result12.consecutivoPeriodo == "8" || Result12.consecutivoPeriodo == "9"){
            if((HoyMes>=10&&HoyAnio==Number(Result12.anio))||(HoyAnio>Number(Result12.anio))){
              this.PeriodoFichaIndividual = Result12.anio + " - 3";
              this.PeriodoCol1 = (Result12.anio) + " - 2";
              this.PeriodoCol2 = Result12.anio + " - 3";
              this.PeriodoCol4 = (Number(Result12.anio)-1) + " - 3";
              this.PeriodoCol5 = Result12.anio + " - 3";
              this.TrimestreConsultaReporte = 3;
              this.InformacionTrimestralFichaIndividual(3);
            }else{
              this.toastr.warning('La información para el trimestre no esta completa.', 'Advertencia!');
            }
          }else if(Result12.consecutivoPeriodo == "10" || Result12.consecutivoPeriodo == "11" || Result12.consecutivoPeriodo == "12"){
            if((HoyMes>=1&&HoyAnio==(Number(Result12.anio)+1))||(HoyAnio>(Number(Result12.anio)+1))){
              this.PeriodoFichaIndividual = Result12.anio + " - 4";
              this.PeriodoCol1 = (Result12.anio) + " - 3";
              this.PeriodoCol2 = Result12.anio + " - 4";
              this.PeriodoCol4 = (Number(Result12.anio)-1) + " - 4";
              this.PeriodoCol5 = Result12.anio + " - 4";
              this.TrimestreConsultaReporte = 4;
              this.InformacionTrimestralFichaIndividual(4);
            }else{
              this.toastr.warning('La información para el trimestre no esta completa.', 'Advertencia!');
            }
          }else{
            this.toastr.error('Error definicion de periodo de consulta.', 'Error!');
          }
        }
      });
    }
  }

  InformacionMensualFichaIndividual(){
    this.CloseModalPreguntaFichaIndividual.nativeElement.click();
    this.OpenModalFichaIndividual.nativeElement.click();
    this.analisisService.fichaAnalisisMensualIndividualFivi(this.PeriodoFichaAnalisisIndividual.consecutivoPeriodo
      ,this.PeriodoFichaAnalisisIndividual.anio,this.EstadoInfomacionFuente.idFuente.id).subscribe(resultado14=>{
        //console.log(resultado14);
        this.FITablaOperFin12ValDes= resultado14.datosTabla1Desembolsos;
        this.FITablaOperFin1ValDes= resultado14.datosTabla2Desembolsos;
        this.FITablaOperFin2ValDes= resultado14.datosTabla3Desembolsos;
        this.FITablaOperFin3ValDes= resultado14.datosTabla4Desembolsos;
        this.FITablaOperFin4ValDes= resultado14.datosTabla5Desembolsos;
        this.FITablaOperFin12NumCre= resultado14.datosTabla1NumeroCreditos;
        this.FITablaOperFin1NumCre= resultado14.datosTabla2NumeroCreditos;
        this.FITablaOperFin2NumCre= resultado14.datosTabla3NumeroCreditos;
        this.FITablaOperFin3NumCre= resultado14.datosTabla4NumeroCreditos;
        this.FITablaOperFin4NumCre= resultado14.datosTabla5NumeroCreditos;
    });
  }

  InformacionTrimestralFichaIndividual(trimestre){
    this.CloseModalPreguntaFichaIndividual.nativeElement.click();
    this.OpenModalFichaIndividual.nativeElement.click();
    this.analisisService.fichaAnalisisTrimestralIndividualFivi(trimestre,this.PeriodoFichaAnalisisIndividual.anio,this.EstadoInfomacionFuente.idFuente.id).subscribe(resultado15=>{
        //console.log(resultado15);
        this.FITablaOperFin12ValDes= resultado15.datosTabla1Desembolsos;
        this.FITablaOperFin1ValDes= resultado15.datosTabla2Desembolsos;
        this.FITablaOperFin2ValDes= resultado15.datosTabla3Desembolsos;
        this.FITablaOperFin3ValDes= resultado15.datosTabla4Desembolsos;
        this.FITablaOperFin4ValDes= resultado15.datosTabla5Desembolsos;
        this.FITablaOperFin12NumCre= resultado15.datosTabla1NumeroCreditos;
        this.FITablaOperFin1NumCre= resultado15.datosTabla2NumeroCreditos;
        this.FITablaOperFin2NumCre= resultado15.datosTabla3NumeroCreditos;
        this.FITablaOperFin3NumCre= resultado15.datosTabla4NumeroCreditos;
        this.FITablaOperFin4NumCre= resultado15.datosTabla5NumeroCreditos;
    });
  }

  ExportarExcelFichaAnalisisIndividual() {
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById('TablaValDesemOperFinan12-fichaInd'));
    XLSX.utils.book_append_sheet(workbook, ws1, "VD OP 1 y 2");
    var ws2 = XLSX.utils.table_to_sheet(document.getElementById('TablaValDesemOperFinan1-fichaInd'));
    XLSX.utils.book_append_sheet(workbook, ws2, "VD OP 1");
    var ws3 = XLSX.utils.table_to_sheet(document.getElementById('TablaValDesemOperFinan2-fichaInd'));
    XLSX.utils.book_append_sheet(workbook, ws3, "VD OP 2");
    var ws4 = XLSX.utils.table_to_sheet(document.getElementById('TablaValDesemOperFinan3-fichaInd'));
    XLSX.utils.book_append_sheet(workbook, ws4, "VD OP 3");
    var ws5 = XLSX.utils.table_to_sheet(document.getElementById('TablaValDesemOperFinan4-fichaInd'));
    XLSX.utils.book_append_sheet(workbook, ws5, "VD OP 4");
    var ws6 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumerCrediOperFinan12-fichaInd'));
    XLSX.utils.book_append_sheet(workbook, ws6, "NC OP 1 y 2");
    var ws7 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumerCrediOperFinan1-fichaInd'));
    XLSX.utils.book_append_sheet(workbook, ws7, "NC OP 1");
    var ws8 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumerCrediOperFinan2-fichaInd'));
    XLSX.utils.book_append_sheet(workbook, ws8, "NC OP 2");
    var ws9 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumerCrediOperFinan3-fichaInd'));
    XLSX.utils.book_append_sheet(workbook, ws9, "NC OP 3");
    var ws10 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumerCrediOperFinan4-fichaInd'));
    XLSX.utils.book_append_sheet(workbook, ws10, "NC OP 4");
    XLSX.writeFile(workbook, "FichaAnalisis"+this.FuenteFichaIndividual.nombEntidad.toString()+".xlsx");
  }

  VerCargue(){
    if(this.VercargueFuente){
      this.VercargueFuente = false;
    } else {
      this.VercargueFuente = true;
      if(this.AprobarcargueFuente){
        this.AprobarcargueFuente = false;
      }
      this.consultarHistorico();
    }
  }

  consultarHistorico(){
    if(this.MensualIndividual){
      this.api.ConsultarReportePeriodoMensual(this.FuenteFichaIndividual.id,this.PeriodoFichaAnalisisIndividual.id).subscribe(Result33 =>{
        this.ResultadoConsulta = Result33;
        if(Result33.length == 0 || Result33 == null){
          this.toastr.error('Existe un problema con la información en requerida.', 'Error!');
        }
      });
    }
    if(this.TrimestralIndividual){
      this.api.ConsultarReportePeriodoTrimestre(this.FuenteFichaIndividual.id,this.PeriodoFichaAnalisisIndividual.id,this.TrimestreConsultaReporte).subscribe(Result34 =>{
        this.ResultadoConsulta = Result34;
        if(Result34.length == 0 || Result34 == null){
          this.toastr.error('Existe un problema con la información en requerida.', 'Error!');
        }
      });
    }

  }

  DescargarCargueMasivo(){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById('TablaConsultaReporte-FichaInd'));
    XLSX.utils.book_append_sheet(workbook, ws1, this.FuenteFichaIndividual.nombEntidad.toString());
    XLSX.writeFile(workbook, "CargueMasivo.xlsx");
  }

  AprobarCargue(){
    if(this.AprobarcargueFuente){
      this.AprobarcargueFuente = false;
    } else {
      this.AprobarcargueFuente = true;
      if(this.VercargueFuente){
        this.VercargueFuente = false;
      }
    }
  }

  ///Importante:
  ///Se esta manejando un historial de cambio de estado de información
  ///Debe implementarce el mismo para esta funcion de guardado
  GuardarAprobacion(){
    //this.EstadoInfomacionFuente.estado = "Aprobado";
    //this.EstadoInfomacionFuente.novedadSis = "99 - Rinde / Novedad reportada";
    this.BtnAprobar = true;
    this.EstadoInfomacionFuente.estado = "Aprobado";
    this.EstadoInfomacionFuente.novedadSis = "99 - Rinde / Novedad reportada";
    if(this.EstadoInfomacionFuente.observacionSis==null){
      this.toastr.warning('Observación obligatoria.', 'Advertencia!');
    } else if(this.EstadoInfomacionFuente.observacionSis.length<=1){
      this.toastr.warning('Observación demasiado corta.', 'Advertencia!');
    } else {
      //console.log(this.EstadoInfomacionFuente);
      this.api.CambiarEstadoInformacionFivi(this.EstadoInfomacionFuente, localStorage.getItem('usuario')).subscribe(Result24=>{
        if(Result24){
          this.toastr.success('Cargue aprobado.', 'OK!');
          this.CloseModalFichaIndividual.nativeElement.click();
          this.CosultarListaEstados(this.IdPeriodoConsulta);
        }
      }, error=>{
        this.toastr.error('No se guardó.', 'Error!');
        this.BtnAprobar = false;
      });
    }
  }

}
